import React, { useState, useEffect } from 'react'
import { Grid, Alert} from '@deere/fuel-react';
import CampaignClosedAlert from '../../components/CampaignClosedAlert';
import LinearProgressIndicator from "../../components/LineProgressIndicator";
import { useLocation } from "react-router-dom";
import ActionsTPSReviewSurvey from '../../components/tps/ActionsTPSReviewSurvey';
import TpsAgreementPopUp from '../../components/modals/TpsAgreementPopUp'
import { useOktaAuth } from '@okta/okta-react'
import { useUserInfo } from '../../providers/userProvider'
import { getCampaigsByRn } from '../../services/campaign.service';
import { ModalSubmit } from '../../components/ModalSubmit';
import { ModalGeneric } from '../../components/ModalGeneric';
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import SurveyTitle from '../../components/SurveyTitle';
import { isValidRequestNumber, validationRules} from '../../utils/utils';
import TPSSectionPage from './TPSSectionPage';
import { getAllCountryList} from '../../services/survey.service'; 
import { getTPSResponseById,deleteTpsResponseByResponseId,submitTpsResponse, submitTpsmexResponse} from '../../services/tps.service'; 
import useTpsContext from '../../hooks/useTpsContext';
import { Context } from  "../../components/tps/TpsContext";
import {TPS_RESPONSE_STATUSES,CRS_REQUEST_STATUS_OBJ, CRS_SURVEY_CODES, TPS_MX_AUTHORIZOR_SECTION, TPS_MX_AUTHORIZOR_SECTION_QUESTION} from "../../utils/surveyLiterals";

export default function ReviewPage() {
    const { t } = useTranslation();
    const history = useHistory();
    const userInfo = useUserInfo();
    const { authState } = useOktaAuth();
    const location = useLocation();
    const [statusSaved, setStatusSaved] = useState(undefined);
    const [survey] = useState(location.state.survey);
    const [assignmentId] = useState(location.state.assignmentId);    
    const [response] = useState(location.state.response);    
    const [campaignAssigned, setCampaignAssigned] = useState();
    const [assignmentsInResponse, setAssignmentsInResponse] = useState([]);
    const [containsError, setContainsError] = useState();
    const[countryList, setCountryList]= useState(undefined);   
    const [tpsResponse,setTpsResponse] = useState();
    const useTps = useTpsContext(Context);
    const sections = survey.sections.filter(q => q.active).sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1)
    
    const [showAgreement, setShowAgreement] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showValidationModal, setShowValidationModal] = useState(false);
    const [validationMsg, setValidationMsg] = useState("");
    const [showGoToSearchModal, setShowGoToSearchModal]= useState(false);
    let signatureAnswer;

    if(survey.code===CRS_SURVEY_CODES.TPSMEX){
        const answers = Array.isArray(useTps.answers) ? useTps.answers : [];
        let authorizerSection= sections?sections.find((section)=>section.code===TPS_MX_AUTHORIZOR_SECTION).questions: null;
        let signatureQuestionId= authorizerSection?authorizerSection.find((que)=>que.code===TPS_MX_AUTHORIZOR_SECTION_QUESTION).id:null;
        signatureAnswer= answers?answers.find((ans)=>ans.questionId===signatureQuestionId)?.answer:null;
    }

    useEffect(() => {
        //Getting the campaign related with the assignment
        if (userInfo && assignmentId && isValidRequestNumber(assignmentId)) {
            getCampaigsByRn(assignmentId, authState.accessToken.accessToken)
            .then((res) => {
                let errorValidation = validationRules(res, userInfo);
                if (errorValidation) { 
                    setContainsError(errorValidation)
                } else {
                    setCampaignAssigned(res);
                }
            }).catch(error => {
                //Campaign not found
                setContainsError('Campaign was not found,please refresh the page if the error persist contact the support department.')
            })            
        }
        if(response && assignmentId && response.id){
            getTPSResponseById(response.id, authState.accessToken.accessToken, survey.code)
            .then((res) => {
                res.tpsResponseSelected = response;
                useTps.updateContext(res);
                setTpsResponse(res);
                const resAssignments = res.assignments ? res.assignments : null;
                let supplierList = resAssignments.map(function(tmpAssignment){
                    return tmpAssignment.supplierNumber;
                })
                setAssignmentsInResponse(resAssignments);
                setValidationMsg("Are you sure you want to delete this response? \n Response No. " + response.id + " \n Supplier(s):" + supplierList.toString() );                
            }).catch(error => {
                console.log(error)
                setContainsError('Response was not found, please refresh the page if the error persist contact the support department.')
            })
        }  
        if(!countryList){
            getAllCountryList(authState.accessToken.accessToken).then(res => {
               if(res){
                 setCountryList(res);
                }
            })
        }    
    }, [assignmentId,response.id,userInfo,authState.accessToken.accessToken]);

    const handleClose = () => setShowAgreement(false);

    const setStatusSubmit = (message) => {
        let statusResponse = { ...message };
        setStatusSaved(statusResponse);
    }

    function handlePrint() {
        window.print();
    }

    const submitResponseFn = () => {
        try {
            
            const tmpResponse = {id: tpsResponse.id,status:TPS_RESPONSE_STATUSES.SUBMITTED}
            submitTpsResponse(tmpResponse, authState.accessToken.accessToken).then((camp) => {
                setStatusSubmit({ status: true, message: "Response submitted succesfully", label: 'Success:', variant: 'success' });
                setShowModal(false);
                if( camp &&  camp.campaignAssignment && camp.campaignAssignment.length>0 && camp.campaignAssignment[0].status===CRS_REQUEST_STATUS_OBJ.COMPLETE) {                     
                     setShowGoToSearchModal(true)
                   }
                else{ 
                    useTps.updateContext({});
                    history.goBack(); 
                }
            })
        } catch (error) {
            console.log(error);
            setStatusSubmit({ status: true, message: error, label: 'Danger:', variant: 'danger' });
            setShowModal(false);
            window.scrollTo(0, 0);
        }
    }

    const submitTpsMexResponseFn = () => {
        try {
            
            const tmpResponse = {id: tpsResponse.id,status:TPS_RESPONSE_STATUSES.SUBMITTED}
            
            submitTpsmexResponse(tmpResponse, authState.accessToken.accessToken).then((camp) => {
                setStatusSubmit({ status: true, message: "Response submitted succesfully", label: 'Success:', variant: 'success' });
                setShowModal(false);
                if( camp &&  camp.campaignAssignment && camp.campaignAssignment.length>0 && camp.campaignAssignment[0].status===CRS_REQUEST_STATUS_OBJ.COMPLETE) {                     
                     setShowGoToSearchModal(true)
                   }
                else{ 
                    useTps.updateContext({});
                    history.goBack(); 
                }
            })
        } catch (error) {
            console.log(error);
            setStatusSubmit({ status: true, message: error, label: 'Danger:', variant: 'danger' });
            setShowModal(false);
            window.scrollTo(0, 0);
        }
    }

    const handleDeleteResponse = () => {
        try {
            deleteTpsResponseByResponseId(tpsResponse.id,authState.accessToken.accessToken, survey.code).then((res) => {
                if(res && res.numberResponsesDeleted && res.numberResponsesDeleted >0){
                    setShowValidationModal(false);
                    useTps.updateContext({});
                    history.goBack();
                }else{
                    setStatusSubmit({ status: true, message: 'Error deleting the response, please refresh the page and try again.', label: 'Success:', variant: 'success' });
                    window.scrollTo(0, 0);        
                }
            })
        } catch (error) {
            console.log(error);
            setStatusSubmit({ status: true, message: error, label: 'Danger:', variant: 'danger' });
            window.scrollTo(0, 0);
        }
        return true;
    };

    const handleShowGoToSearchModal= ()=>{
        history.push({
            pathname: '/',
            state: { previous: history.location.pathname }
        })
    }

    const backToEdit = () =>{
        history.goBack();
    }

    return campaignAssigned ?
            (<Grid container>
                <Grid item xs={12}>
                    <SurveyTitle survey={survey} assignment={campaignAssigned.assignments[0]} latestResponse={tpsResponse} handlePrint={handlePrint} endDate={campaignAssigned.endDate}/>
                </Grid>
                <Grid item xs={12}>
                    {
                    (statusSaved && statusSaved.status) &&
                        <Alert variant={'success'} title={statusSaved.label}>{statusSaved.message}</Alert>
                    }
                    {
                    containsError &&
                        <Alert variant={'error'} title={'Error'}>{containsError}</Alert>
                    }
                    <CampaignClosedAlert campaign={campaignAssigned} />
                    {                        
                        sections.sort((a,b) => (a.showOrder > b.showOrder)? 1 : -1).map((section,index) =>
                            // (section.showOrder===4)&& 
                            <TPSSectionPage key={`section-${section.id}`} review section={section} survey={survey}  campaign={campaignAssigned} tpsResponses={null} countryList={countryList}
                            />
                        )
                    }
                    {campaignAssigned && <ActionsTPSReviewSurvey setShowAgreement={setShowAgreement} tpsResponse={tpsResponse} setShowValidation={setShowValidationModal} campaign={campaignAssigned} backToEdit={backToEdit} survey={survey}/>}
                    <TpsAgreementPopUp showAgreement={showAgreement} handleClose={handleClose} submitResponse={survey.code===CRS_SURVEY_CODES.TPS?submitResponseFn:submitTpsMexResponseFn} survey={survey} signature={signatureAnswer}/>
                    <ModalSubmit showModal={showModal} setShowModal = {setShowModal} titleKey={'survey_submit_modal_title'} messageKey={'submit_popup_message'}/>
                    <ModalGeneric showModal={showValidationModal}
                           setShowModal ={setShowValidationModal} 
                           labelBtnPrimary={t('t2_remove')}
                           labelBtnSecondary={t('btn_cancel')}
                           handleSubmit={handleDeleteResponse}
                           msgModal={validationMsg}
                           titleModal={t('t2_remove')}
                    />
                    <ModalSubmit showModal={showGoToSearchModal}
                        setShowModal={setShowGoToSearchModal} 
                        titleKey={'cm_lbl_request_completed_title'}
                        messageKey={'cm_lbl_request_completed_message'}
                        buttonKey={'btn_OK'}
                    />
                </Grid>
            </Grid>
        )      
        : <Grid container>
            <Grid item xs={6} md={12}>
                <LinearProgressIndicator title='Loading' subtitle='This will take a couple of seconds'/>
            </Grid>
        </Grid>
}